import { BrowserModule } from '@angular/platform-browser'
import { NgModule } from '@angular/core'

import { AppRoutingModule } from './app-routing.module'
import { AppComponent } from './app.component'
import { LayoutModule } from './layout/layout.module'
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http'
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome'
import { Interceptor } from './core/authentication/interceptor'
import { TooltipModule } from 'ngx-bootstrap/tooltip'
import { SharedModule } from './modules/shared/shared.module'
import { PagesModule } from './modules/pages/pages.module'
import { regularIcons } from './modules/shared/utils/fa-regular-icons'
import { solidIcons } from './modules/shared/utils/fa-solid-icons'

// NOT RECOMMENDED (Angular 9 doesn't support this kind of import)
@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    LayoutModule,
    HttpClientModule,
    FontAwesomeModule,
    SharedModule,
    PagesModule,
    TooltipModule.forRoot(),
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: Interceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(library: FaIconLibrary) {
    library.addIcons(...regularIcons)
    library.addIcons(...solidIcons)
  }
}
